import {
  CALCULATE_USER_SALARY_SUCCESS,
  LOAD_USER_SALARY_HISTORY_SUCCESS,
  UPDATE_SALARY_HISTORY_SUCCESS,
} from 'constants/ActionTypes';
import { fromJS } from 'immutable';
import { normalizeEntities, sortDate } from 'helpers/utilHelpers';
import { backendDateFormat } from 'util/config';

const initialState = fromJS({
  history: {},
  meta: {
    months: [],
  },
});

const salaryHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_USER_SALARY_HISTORY_SUCCESS: {
      let months = state.getIn(['meta', 'months']);
      action.history._meta.months.forEach((month) => {
        if (!months.includes(month)) {
          months = months.push(month);
        }
      });
      return state.set('history', normalizeEntities(action.history.items, 'salaryId', state.get('history'))).setIn(
        ['meta', 'months'],
        months.sort((a, b) => -sortDate(a, b, backendDateFormat)),
      );
    }
    case CALCULATE_USER_SALARY_SUCCESS: {
      let newState = state;
      if (!Array.isArray(action.salaries)) {
        return state;
      }

      let months = state.getIn(['meta', 'months']);
      action.salaries.forEach((salary) => {
        let salaryId = salary.historyId ? salary.historyId : 'pre-calculate';

        if (!months.includes(salary.date)) {
          months = months.push(salary.date);
        }

        newState = newState.setIn(['history', salaryId], fromJS(salary));
      });
      return newState.setIn(
        ['meta', 'months'],
        months.sort((a, b) => -sortDate(a, b, backendDateFormat)),
      );
    }
    case UPDATE_SALARY_HISTORY_SUCCESS:
      return state.setIn(['history', action.salary.salaryId], fromJS(action.salary));
    default:
      return state;
  }
};

export default salaryHistoryReducer;
